<template>
  <div class="k-filter__switcher" :class="getColorClass">
    <span
      class="k-filter__switcher-item"
      :class="{ active: currentActiveItem === item.tab }"
      @click="currentActiveItem = item.tab"
      v-for="(item, index) in items" 
      :key="index"
    >{{ item.title }}</span>
    <div class="loading-indication" v-if="busy">
      <k-spinner low/>
    </div>
  </div>
</template>

<script>
import KSpinner from './TheSpinner';
export default {
  components: { KSpinner },
  props: {
    busy: Boolean,
    color: {
      type: String,
      default: 'yellow'
    },
    items: {
      type: Array,
      default: () => [],
    },
    activeItem: {
      type: String,
      default: '',
    }
  },
  computed: {
    getColorClass() {
      return `k-filter__switcher--${this.color}`
    },
    currentActiveItem: {
      get() { return this.activeItem },
      set(value) { this.$emit('update:activeItem', value) }
    }
  }
}
</script>

<style lang="scss" scoped>
.k-filter__switcher {
  height: 29px;
  max-width: 100%;
  display: flex;
  position: relative;
}
.k-filter__switcher-item {
  padding: 0 20px;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  line-height: 1.2;
  
  &:first-child {
    border-radius: 6px 0px 0px 6px;
  }

  &:last-child {
    border-radius: 0px 6px 6px 0px;
    &:not(.active) {
      border-right: 1px solid #b2b2b2;
    }
  }

  &.active + & {
    border-left: 1px solid transparent !important;
  }

  &:not(.active) {
    border-top: 1px solid #B2B2B2;
    border-bottom: 1px solid #B2B2B2;
    border-left: 1px solid #B2B2B2;
  }
}

// Themes
.k-filter__switcher--yellow .k-filter__switcher-item.active {
  background: #FFCC1B;
}
.k-filter__switcher--orange .k-filter__switcher-item.active {
  background: #F7981E;
  color: #fff;
}
</style>